<template>
<!-- 所有父菜单的component -->
    <router-view></router-view>
</template>
<script>
export default {
    name: 'Layout'
}
</script>
